export default "assets/images/icons/arrow-white-circle-blue-68a80d49.svg";